import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import PageSizeStation from '../../../shared/component/PageSizeStation';
import { LIMIT_PAGE_NUM } from '../../../shared/constants/limits';
import { PerPage } from '../../../shared/enum/EnumRepository';
import { useAdminExhibition } from '../../share/hook/useAdminExhibition';
import { runAfterExhibitionListContextChange } from './runAfterUnsavedExhibitionCheck';

const PageAboutExhibition: React.FC = () => {
  const { page, totalPages, pageSize, setPageSize, load } = useAdminExhibition();
  const [currentWindow, setCurrentWindow] = useState(1);
  const startPage = (currentWindow - 1) * LIMIT_PAGE_NUM + 1;
  const endPage = Math.min(startPage + LIMIT_PAGE_NUM - 1, totalPages);

  useEffect(() => {
    setCurrentWindow(Math.max(1, Math.ceil(page / LIMIT_PAGE_NUM)));
  }, [page]);

  const moveToPage = (nextPage: number) => {
    runAfterExhibitionListContextChange(() => {
      void load(nextPage, Number(pageSize));
    });
  };

  return (
    <PageContainer>
      <PageButtonContainer>
        {currentWindow > 1 && (
          <PageButton type="button" onClick={() => moveToPage(startPage - LIMIT_PAGE_NUM)}>←</PageButton>
        )}
        {Array.from(
          { length: Math.max(0, endPage - startPage + 1) },
          (_, index) => startPage + index,
        ).map((pageNumber) => (
          pageNumber === page ? (
            <CurrPageButton key={pageNumber} type="button" disabled>{pageNumber}</CurrPageButton>
          ) : (
            <PageButton key={pageNumber} type="button" onClick={() => moveToPage(pageNumber)}>
              {pageNumber}
            </PageButton>
          )
        ))}
        {currentWindow < Math.ceil(totalPages / LIMIT_PAGE_NUM) && (
          <PageButton type="button" onClick={() => moveToPage(endPage + 1)}>→</PageButton>
        )}
      </PageButtonContainer>
      <PageSizeStationWrapper>
        <PageSizeStation
          currentValue={pageSize}
          handlePerPageChange={(value: PerPage) => {
            runAfterExhibitionListContextChange(() => setPageSize(value));
          }}
          direction={true}
        />
      </PageSizeStationWrapper>
    </PageContainer>
  );
};

const PageContainer = styled.div`
  width: 100%;
  height: calc(3.5vh);
  max-height: 30px;
  display: flex;
  align-items: center;
  gap: 30px;
  overflow: visible;
  ${({ theme }) => theme.typography.Body_04};
`;

const PageButtonContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

const PageButton = styled.button`
  width: fit-content;
  height: 100%;
  padding: 2px 0 0;
  border: none;
  background: none;
  font: inherit;
  cursor: pointer;
  color: ${({ theme }) => theme.colors.color_Gray_05};
`;

const CurrPageButton = styled(PageButton)`
  color: ${({ theme }) => theme.colors.color_Gray_02};
  cursor: default;
`;

const PageSizeStationWrapper = styled.div`
  position: relative;
  z-index: 4;
  overflow: visible;
`;

export default PageAboutExhibition;
